<% var component = new Anvil.models.components.Text(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col<%- ('width' in field) ? `-${field.width}` : '' %>">
	<% if ('prepend' in field || 'append' in field) { %><div class="input-group"><% } %>
	<% if ('prepend' in field) { %><%- field.prepend %><% } %>
	<input type="<% if ('variant' in field) { %><%- field.variant %><% } else { %>text<% } %>" class="form-control" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" value="<%= form.data[field.name] %>" <% if ('datalist' in field) { %>list="<%- component.id %>_datalist"<% } %> <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
	<% if ('append' in field) { %><%- field.append %><% } %>
	<% if ('prepend' in field || 'append' in field) { %></div><% } %>
	<% if ('datalist' in field && Array.isArray(field.datalist)) { %>
	<datalist id="<%- component.id %>_datalist"><% for (let entry of field.datalist) { %><option value="<%- entry %>" /><% } %></datalist>
	<% } %>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<% if ('prepend' in field || 'append' in field) { %><div class="input-group"><% } %>
		<% if ('prepend' in field) { %><%- field.prepend %><% } %>
		<input type="<% if ('variant' in field) { %><%- field.variant %><% } else { %>text<% } %>" class="form-control" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" value="<%= form.data[field.name] %>" <% if ('datalist' in field) { %>list="<%- component.id %>_datalist"<% } %> <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
		<% if ('append' in field) { %><%- field.append %><% } %>
		<% if ('prepend' in field || 'append' in field) { %></div><% } %>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
		<% if ('datalist' in field && Array.isArray(field.datalist)) { %>
		<datalist id="<%- component.id %>_datalist"><% for (let entry of field.datalist) { %><option value="<%- entry %>" /><% } %></datalist>
		<% } %>
	</div>
</div>
<% } %>
